/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/padlock_medium'
export default icon
